module.exports = __webpack_public_path__ + "static/media/Skip.949f0d8d.jpg";